<template>
  <select
    class="form-control"
    v-bind="$attrs"
    :value="value"
    @change="onSelectOption"
    v-on="$listeners"
  >
    <option :value="null" :selected="notSelected" v-if="!noCaption">{{
      placeholder || $t('select')
    }}</option>
    <option
      v-for="option in optionsForSelect"
      :value="option.value"
      :selected="option.value === value"
      >{{ option.text }}</option
    >
  </select>
</template>

<script>
export default {
  name: 'TsSelect',
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {},
    options: {
      type: Array | Object,
      default: () => []
    },
    noCaption: {
      type: Boolean,
      default: false
    },
    placeholder: String
  },
  computed: {
    notSelected() {
      return !this.options.includes(this.value)
    },
    optionsForSelect() {
      if (Array.isArray(this.options)) {
        return this.options.map(option => {
          return typeof option !== 'object'
            ? { value: option, text: option }
            : option
        })
      } else if (typeof this.options === 'object') {
        return Object.keys(this.options).map(key => {
          return { value: key, text: this.options[key] }
        })
      }
    }
  },
  methods: {
    onSelectOption(event) {
      const selectedValue = this.optionsForSelect[
        event.target.selectedIndex - 1
      ]

      if (selectedValue === undefined) {
        this.$emit('input', null)
      } else if (typeof selectedValue === 'object') {
        this.$emit('input', selectedValue.value)
      } else {
        this.$emit('input', selectedValue)
      }
    }
  }
}
</script>
